import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        gap: 'var(--space-4)',
      }}
    >
      <p className="mono" style={{ color: 'var(--color-text-muted)' }}>404</p>
      <h1 className="page-title">Page not found</h1>
      <Link
        to="/dashboard"
        style={{
          color: 'var(--color-brand)',
          fontSize: 'var(--text-sm)',
          textDecoration: 'underline',
        }}
      >
        Back to dashboard
      </Link>
    </div>
  );
}
